module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1146.8d13ed5d.png";